import React, { Component } from "react";
import { Chrono } from "react-chrono";

class Experience extends Component {

    constructor(props) {
        super(props);
        this.items = [
            {
                title: "July 2022 - Dec 2022",
                cardTitle: "Microsoft",
                media: {
                    name: "Logo",
                    source: {
                        url: "https://firebasestorage.googleapis.com/v0/b/my-portfolio-a8cf3.appspot.com/o/logos%2Fmicrosoft-logo.jpeg?alt=media&token=53563210-9d2f-486f-9734-c7d55ccd3652"
                    },
                    type: "IMAGE"
                },
                cardSubtitle:
                    "Full Stack Developer",
                cardDetailedText: ["Description:  I was part of team where we developed an full stack web application for the Indian public sector. I was responsible for developing maintainable, and resilient code that is scalable, high-performance, highly available, and low latency."],
            },
            {
                title: "February 2022 - March 2022",
                cardTitle: "PiByThree",
                media: {
                    name: "Logo",
                    source: {
                        url: "https://firebasestorage.googleapis.com/v0/b/my-portfolio-a8cf3.appspot.com/o/logos%2Flogo-pibythree.png?alt=media&token=b4c2ed21-d46c-4eff-8231-a63da6ed06a4"
                    },
                    type: "IMAGE"
                },
                cardSubtitle:
                    "Software Developer",
                cardDetailedText: ["Description:  Liaised with the founding team to analyze the product's initial architecture and components. Developed the platform's frontend using React and binding all tested and refactored API endpoints to the UI. Tested and delivered a working prototype of the company's first-ever propriety release R1."],
            },
            {
                title: "June 2021 - Nov 2021",
                cardTitle: "Tech Mahindra",
                media: {
                    name: "Logo",
                    source: {
                        url: "https://firebasestorage.googleapis.com/v0/b/my-portfolio-a8cf3.appspot.com/o/logos%2FtechMLogo.jpeg?alt=media&token=e275cdf7-d6e3-458f-a018-b1747f3a94ae"
                    },
                    type: "IMAGE"
                },
                cardSubtitle:
                    "Software Developer",
                cardDetailedText: ["Description: As a lead software engineer, I collaborated with my team to create a module called 'Snowflake Monitoring and Tracking' for an application called 'Sprinter Data - Snowflake Data Cloud Migration Accelerator.'", "We created a seamless dashboard for the firm's clients to assess their utilization of the snowflake data cloud platform by eliminating the requirement for a third-party service by establishing a native dashboard for the company. Furthermore, we attempted to extract useful intelligence from the product in order to optimise key internal business operations."],
            },
            {
                title: "Jan 2021 - Apr 2021",
                cardTitle: "Swayam Consultants",
                media: {
                    name: "Logo",
                    source: {
                        url: "https://firebasestorage.googleapis.com/v0/b/my-portfolio-a8cf3.appspot.com/o/logos%2FswayamLogo.png?alt=media&token=00c734fa-d496-40fe-a7c7-cc9d3b0d0d19"
                    },
                    type: "IMAGE"
                },
                cardSubtitle:
                    "Data Science Intern",
                cardDetailedText: ["Description: As a part of Data Analytics, I thoroughly analyzed numerous datasets which subsumed employee details, transactions, pay rates, etc.", "In addition, I was a part of the testing process, in which the Payroll System was evaluated on multiple datasets to verify that it is efficient and complies with all company and state regulations. I was able to uncover a few aberrant and erroneous behaviors within the payroll system after extensive testing."],
            },
            {
                title: "June 2019 - July 2019",
                cardTitle: "K.J. Somaiya College Of Engineering",
                media: {
                    name: "Logo",
                    source: {
                        url: "https://firebasestorage.googleapis.com/v0/b/my-portfolio-a8cf3.appspot.com/o/logos%2FsomaiyaLogo.jpeg?alt=media&token=2b62eb87-1e05-405f-b5e9-38a5850f1259"
                    },
                    type: "IMAGE"
                },
                cardSubtitle:
                    "Web Development Using Flask, Internship",
                cardDetailedText: ["Description: We developed an educational website for freshmen to provide them effortless access to course materials and test series, allowing them to prepare for the exam with more convenience."],
            },
            {
                title: "2018 - 2022",
                cardTitle: "K.J. Somaiya College Of Engineering",
                media: {
                    name: "Logo",
                    source: {
                        url: "https://firebasestorage.googleapis.com/v0/b/my-portfolio-a8cf3.appspot.com/o/logos%2FsomaiyaLogo.jpeg?alt=media&token=2b62eb87-1e05-405f-b5e9-38a5850f1259"
                    },
                    type: "IMAGE"
                },
                cardSubtitle:
                    "Bachelor of Technology - BTech, Computer Engineering",
                cardDetailedText: ["Grade: 9.1", "Activities: Professional Football Player at KJSCE"],
            },
            {
                title: "2016 - 2018",
                cardTitle: "SHETH N. K. T. T. JUNIOR COLLEGE",
                media: {
                    name: "Logo",
                    source: {
                        url: "https://firebasestorage.googleapis.com/v0/b/my-portfolio-a8cf3.appspot.com/o/logos%2FnktLogo.png?alt=media&token=9f6f244a-b156-4ebc-896e-5bcf7b694fc3"
                    },
                    type: "IMAGE"
                },
                cardSubtitle:
                    "HSC, Science",
                cardDetailedText: ["Grade: 90.15%", "Achievements: INSPIRE Scholarship for Higher Education"],
            },
            {
                title: "2005 - 2016",
                cardTitle: "Smt. Sulochanadevi Singhania School",
                media: {
                    name: "Logo",
                    source: {
                        url: "https://firebasestorage.googleapis.com/v0/b/my-portfolio-a8cf3.appspot.com/o/logos%2FsinghaniaLogo.png?alt=media&token=5f4d17c2-9cea-4abf-9ab4-28b75596bb23"
                    },
                    type: "IMAGE"
                },
                cardSubtitle:
                    "ICSE",
                cardDetailedText: ["Grade: 96.83%", "Activities & Achievements: Honour Society Member, Volleyball Team, Kabaddi Team, FLT/CDT Rank In National Cadet Corps",
                    "- Received Merit Prize for securing above 90% in ICSE Exam.", "-Completed NASA's Kennedy Space Center Camp in Florida."],
            },];
    }


    render() {

        return (
            <section id="resume" className="pb-5">
                <div className="col-auto mx-auto" >

                    <Chrono
                        items={this.items}
                        mode="VERTICAL_ALTERNATING"
                        scrollable={{scrollbar: true}}
                        theme={{
                            primary: "black",
                            secondary: "white",
                            cardBgColor: "#efefef",
                            cardForeColor: "black",
                            titleColor: "black"
                        }}
                    />

                    {/*<VerticalTimeline
                        lineColor='#AE944F'
                    >
                        <VerticalTimelineElement
                            className="vertical-timeline-element--work"
                            date="June 2021 - Present"
                            iconStyle={{
                                background: "#AE944F",
                                color: "#fff",
                                textAlign: "center",
                            }}
                            icon={<i className="fab fa-angular experience-icon"></i>}
                            contentStyle={{ background: '#AE944F', color: '#000' }}
                            contentArrowStyle={{ borderRight: '7px solid  #AE944F' }}
                        >

                            <h3
                                className="vertical-timeline-element-title"
                                style={{ textAlign: "left" }}
                            >
                                Software Developer
                            </h3>
                            <h4
                                className="vertical-timeline-element-subtitle"
                                style={{ textAlign: "left" }}
                            >
                                Tech M
                            </h4>
                            <div style={{ textAlign: "left", marginTop: "15px" }}><Badge pill className="experience-badge mr-2 mb-2">
                                Node
                            </Badge></div>
                        </VerticalTimelineElement>

                        <VerticalTimelineElement
                            className="vertical-timeline-element--work"
                            contentStyle={{ background: 'rgb(33, 150, 243)', color: '#000' }}
                            contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
                            date="2011 - present"
                            iconStyle={{
                                background: "#AE944F",
                                color: "#fff",
                                textAlign: "center",
                            }}
                            icon={<i className="fab fa-angular experience-icon"></i>}

                        >
                            <h3 className="vertical-timeline-element-title">Creative Director</h3>
                            <h4 className="vertical-timeline-element-subtitle">Miami, FL</h4>
                            <p>
                                Creative Direction, User Experience, Visual Design, Project Management, Team Leading
                            </p>
                        </VerticalTimelineElement>

                        <VerticalTimelineElement
                            className="vertical-timeline-element--education"
                            contentStyle={{ background: 'rgb(233, 30, 99)', color: '#000' }}
                            contentArrowStyle={{ borderRight: '7px solid  rgb(233, 30, 99)' }}
                            date="April 2013"
                            iconStyle={{ background: 'rgb(233, 30, 99)', color: '#fff' }}

                        >
                            <h3 className="vertical-timeline-element-title">Content Marketing for Web, Mobile and Social Media</h3>
                            <h4 className="vertical-timeline-element-subtitle">Online Course</h4>
                            <p>
                                Strategy, Social Media
                            </p>
                        </VerticalTimelineElement>

                        <VerticalTimelineElement
                            iconStyle={{ background: 'rgb(16, 204, 82)', color: '#fff' }}
                            contentStyle={{ background: 'rgb(16, 204, 82)', color: '#000' }}
                            contentArrowStyle={{ borderRight: '7px solid  rgb(16, 204, 82)' }}
                            date="April 2013"

                        >
                            <h3 className="vertical-timeline-element-title">Content Marketing for Web, Mobile and Social Media</h3>
                            <h4 className="vertical-timeline-element-subtitle">Online Course</h4>
                            <p>
                                Strategy, Social Media
                            </p>
                        </VerticalTimelineElement>

                    </VerticalTimeline> */}

                </div>
            </section>
        );
    }
}

export default Experience;